import { RectForPicket } from './RectForPicket';
import { Selectable } from '../Selectable';
import { IntPicket } from './IntPicket';
import { Sphere } from './Sphere';
import { TextPost } from './textPost';
declare const THREE: any;

export class SelectablePicket extends Selectable {
  loader = new THREE.ImageLoader();
  static readonly Name = 'Picket';

  private picture = new THREE.ImageLoader().load('../../../../../assets/images/scene-plan/sc.png');

  public type: string = 'SC';
  public labelPos: string = 'Center';
  public scaleCor;
  public modifiedAtStep3: boolean = false;

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
  text: any;

  constructor(edge?: Feeney.IEdge) {
    super();
    if (edge) {
      this.add(new IntPicket(edge));
    } else {
      this.add(new IntPicket());
    }
    this.add(new Sphere('#000000'));
    this.scaleCor = 1;
    this.text = "";
    this.labelPos = "Center";
  }

  addEditableLabel(type, text) {
    this.type = type.postType;
    this.labelPos = type.labelPosition;
    this.text = text.toUpperCase();
    if (this.labelPos !== "Center") {
      this.add(new TextPost(this.text.toUpperCase(), this.labelPos));
      this.children.filter(ch => ch.name === 'textPost').forEach(ch => {
        ch.setLabelPos();
      });
    }
  }

  addLabel(type, picture?) {
    // let mesh;
    // this.children.filter(ch => ch.name === "text").forEach(ch => {
    //   mesh = ch;
    // });

    this.type = type.postType;
    this.labelPos = type.labelPosition;
    if (picture) {
      this.picture = picture;
    }

    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(
      SelectablePicket.rotationTransform
    );
    const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });

    let mesh = new THREE.Mesh(geometry, material);

    let canvas = document.createElement('canvas');

    let ctx = canvas.getContext('2d');

    mesh.scale.set((10 / this.picture.height) * this.picture.width, 1, 8);
    canvas.width = (10 / this.picture.height) * this.picture.width * 10;
    canvas.height = 8 * 10;

    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this.picture, 0, -canvas.height / 10, canvas.width, canvas.height * 1.2);

    if (!mesh.material.map) {
      mesh.material.map = new THREE.Texture(canvas);
    }
    mesh.material.map.image = canvas;

    mesh.material.map.needsUpdate = true;
    mesh.material.needsUpdate = true;

    mesh.name = 'text';

    this.add(mesh);
    // mesh.position = this.position;
    this.name = SelectablePicket.Name;

    let vect = [
      new THREE.Vector3(12, 0, 0),
      new THREE.Vector3(0, 0, 12),
      new THREE.Vector3(-12, 0, 0),
      new THREE.Vector3(0, 0, -12)
    ];

    for (let i = 0; i < 4; i++) {
      let x = vect[i].x * Math.cos(mesh.rotation.y) + vect[i].z * Math.sin(mesh.rotation.y);
      let z = vect[i].z * Math.cos(mesh.rotation.y) - vect[i].x * Math.sin(mesh.rotation.y);
      vect[i] = new THREE.Vector3(x, 0, z);
    }
    // let pos = mesh.getWorldPosition();
    // mesh.applyMatrix( this.matrixWorld );

    if (mesh) {
      switch (this.labelPos) {
        case 'Above':
          mesh.position.add(vect[3]);
          break;
        case 'Left Side':
          mesh.position.add(vect[2]);
          break;
        case 'Right Side':
          mesh.position.add(vect[0]);
          break;
        case 'Below':
          mesh.position.add(vect[1]);
          break;
        default:
          mesh.visible = false;
          break;

      }
    }
  }

  private getNestedPost(): IntPicket {
    return this.getObjectByName<IntPicket>(IntPicket.Name);
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName<RectForPicket>(RectForPicket.Name)];
  }

  update() {
    this.getNestedPost().update();
    (<any>this).scale.set(this.scaleCor, 1, this.scaleCor);
    this.children.forEach(ch => {
      if (ch instanceof Sphere) {
        ch.scale.set(1 / this.scaleCor, 1, 1 / this.scaleCor);
      }
    })
  }

  get edge() {
    return this.getNestedPost().edge;
  }

  getSize(): number {
    return this.getNestedPost().getSize();
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    let rot = {
      x: this.rotation.x,
      y: this.rotation.y,
      z: this.rotation.z
    }
    return {
      type: "Picket",
      position: pos,
      rotation: rot,
      scaleCor: this.scaleCor,
      typeP: { postType: this.type, labelPosition: this.labelPos },
      imageSrc: this.picture ? this.picture.src : undefined,
      text: this.text
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/SelectablePicket.ts